import { render } from "./pagination.vue?vue&type=template&id=46ab158e&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=46ab158e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ab158e"]])

export default __exports__